import React from "react";

interface TenantCardProps {
  description: string;
  imageUrl: string;
  handleClick: () => void;
  disabled?: boolean;
  darkmode?: boolean;
}

const TenantCard: React.FC<TenantCardProps> = ({
  description,
  imageUrl,
  handleClick,
  disabled = false,
  darkmode,
}) => {
  return (
    <div
      className={`relative flex flex-col justify-center items-center p-5 gap-2 h-[178px] w-[370px] bg-[oklch(1_0_0/0.5)] border shadow-md rounded-2xl transition-shadow duration-300 ${
        darkmode ? "dark:bg-[oklch(0_0_0/0.5)]" : ""
      } ${
        disabled
          ? "cursor-not-allowed opacity-80"
          : "cursor-pointer hover:shadow-lg hover:border-primary"
      }`}
      onClick={disabled ? undefined : handleClick}
    >
      {disabled && (
        <div
          className={`absolute inset-0 bg-gray-50/40 rounded-2xl z-10 ${darkmode ? "bg-gray-800/40" : ""}`}
        />
      )}

      <div className="flex items-center justify-center h-[50%] w-full">
        <img
          src={imageUrl}
          alt="CompanyLogo"
          className="max-w-[50%] max-h-full object-contain"
        />
      </div>

      <p className="text-body-xlarge-semibold pt-2 text-center">
        {description}
      </p>
    </div>
  );
};

export default TenantCard;
